import { render, staticRenderFns } from "./contractAdd.vue?vue&type=template&id=67511145&scoped=true&"
import script from "./contractAdd.vue?vue&type=script&lang=js&"
export * from "./contractAdd.vue?vue&type=script&lang=js&"
import style0 from "./contractAdd.vue?vue&type=style&index=0&id=67511145&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67511145",
  null
  
)

export default component.exports